import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    links = [
        {
            name: 'json config',
            path: 'form-config'
        },
        {
            name: 'performance',
            path: 'form-performance'
        },
        {
            name: 'interaction',
            path: 'form-interaction'
        },
        {
            name: 'fill',
            path: 'fill-form'
        },
        {
            name: 'layouts',
            path: 'form-layouts'
        }
    ];

    constructor(public readonly  translate: TranslateService) {
    }

    public changeLanguage(lng: string) {
        this.translate.use(lng.toLowerCase());
    }
}
